module.exports = __webpack_public_path__ + "media/application/images/svgs/credit-card-80ed80aefe8548370dddfe5de3ac8a9c.svg";